export const CREATE_COMMNET_REQUEST = 'CREATE_COMMNET_REQUEST';
export const CREATE_COMMNET_SUCCESS = 'CREATE_COMMNET_SUCCESS';
export const CREATE_COMMNET_FAILURE = 'CREATE_COMMNET_FAILURE';
export const FETCH_COMMNET_REQUEST = 'FETCH_COMMNET_REQUEST';
export const COMMENT_STATUS_UPDATE_SUCCESS = 'COMMENT_STATUS_UPDATE_SUCCESS';
export const COMMENT_DELETE_SUCCESS = 'COMMENT_DELETE_SUCCESS';
export const COMMENT_DELETE_FAILULE = 'COMMENT_DELETE_FAILULE';
